import { ResetPasswordModel } from './../../../../../core/auth/_models/resetPasswordModel';
import { ForgetPasswordModel } from './../../../../../core/auth/_models/forgetPasswordModel';
import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { AuthService, AuthNoticeService } from "../../../../../core/auth";
import { Router } from "@angular/router";
import { tap, takeUntil, finalize } from "rxjs/operators";
import { ConfirmPasswordValidator } from '../../../shared/validators/confirm-password.validator';
import './../../../shared/extension-method';
import { SharedObject } from '../../../shared/sharedObject';
@Component({
  // tslint:disable-next-line: component-selector
  selector: "kt-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ['forgot-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  // Public params
  forgotPasswordForm: FormGroup;
  enterNewPasswordForm: FormGroup;
  loading = false;
  errors: any = [];
  succesfulPasswordChangesStatus: boolean = false;
  newpasswordLevel: boolean = false;//مرحله وارد کردن رمز جدید
  private unsubscribe: Subject<any>; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

  /**
   * Component constructor
   *
   * @param authService
   * @param authNoticeService
   * @param translate
   * @param router
   * @param fb
   * @param cdr
   */
  constructor(
    private authService: AuthService,
    public authNoticeService: AuthNoticeService,
    private router: Router,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    this.unsubscribe = new Subject();
  }

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */
  ngOnInit() {
    this.forgotPasswordForm = this.fb.group({
      mobileNumber: [null, Validators.compose([
        Validators.required,
        Validators.minLength(11),
        Validators.maxLength(11),
        Validators.pattern(SharedObject.MobilePattern)
      ])
      ]
    });
    //-----------------------------------------------------------------------------------
    this.enterNewPasswordForm = this.fb.group({
      code: [null, Validators.compose([
        Validators.required,
        Validators.pattern('[0-9|۰-۹]{5}')
      ])
      ],
      password: ['', Validators.compose([
        Validators.required,
        Validators.pattern(SharedObject.PasswordPattern)
      ])
      ],
      confirmPassword: ['', Validators.compose([
        Validators.required,
        Validators.pattern(SharedObject.PasswordPattern)
      ])
      ]
    }, {
        validator: ConfirmPasswordValidator.MatchPassword
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    if (!this.succesfulPasswordChangesStatus)
      this.authNoticeService.setNotice('');
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.loading = false;
  }
  readyCodeLinkClick() {
    const controls = this.forgotPasswordForm.controls;
    /** check form */
    if (this.forgotPasswordForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }
    this.newpasswordLevel = true;
  }


  /**
   * Form Submit
   */
  submitMobile() {
    const controls = this.forgotPasswordForm.controls;
    /** check form */
    if (this.forgotPasswordForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }
    this.loading = true;
    const model: ForgetPasswordModel = new ForgetPasswordModel();
    model.userName = controls['mobileNumber'].value.FaToEnDigits();
    this.authService.forgetPassword(model).subscribe(res => {
      this.authNoticeService.setNotice("کد تأیید به شماره موبایل ارسال شد لطفا آن را وارد کنید", "brand");
      this.newpasswordLevel = true;
      this.loading = false;
    }, err => {
      this.loading = false;
      this.authNoticeService.setNotice('  خطا ' + err.error.result, "danger");
      this.cdr.markForCheck();
    }, () => {
      this.loading = false;
      this.cdr.markForCheck();
    })
  }

  submitCode() {
    //چک کردن دوباره اینکه آیا در مرحله قبل شماره موبایل را وارد کرده بود
    const mobileFormcontrols = this.forgotPasswordForm.controls;
    /** check form */
    if (this.forgotPasswordForm.invalid) {
      Object.keys(mobileFormcontrols).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      this.newpasswordLevel = false;
      return;
    }
    //-------------------------------------------------------------------------
    const controls = this.enterNewPasswordForm.controls;
    /** check form */
    if (this.enterNewPasswordForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }
    this.loading = true;
    const model: ResetPasswordModel = new ResetPasswordModel();
    model.phoneNumber = mobileFormcontrols['mobileNumber'].value.FaToEnDigits();
    model.code = controls['code'].value.FaToEnDigits();
    model.password = controls['password'].value.FaToEnDigits();
   (model);
    this.authService.resetPassword(model).subscribe(res => {
      this.authNoticeService.setNotice("رمز عبور شما با موفقیت تغییر یافت", "success");
      this.succesfulPasswordChangesStatus = true;
      this.router.navigateByUrl("/auth/login");
      this.loading = false;
    }, err => {
      this.loading = false;
      this.authNoticeService.setNotice('  خطا ' + err.error.result, "danger");
      this.cdr.markForCheck();
    }, () => {
      this.loading = false;
      this.cdr.markForCheck();
    })

  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.forgotPasswordForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result =
      control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }
  isenterNewPasswordControlHasError(controlName: string, validationType: string): boolean {
    const control = this.enterNewPasswordForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result =
      control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }
}
